class SmiffysProductAccessories extends HTMLElement {
    addSelectionToBasket = async () => {
        let addToBasketItems = []
        for (const accessory of this.querySelectorAll('.product_accessories_item')) {
            if (accessory.querySelector('input[type=checkbox]').checked) {
                let accessoryselectedVarintId = +accessory.querySelector('[name="varaintId"]').value;
                let properties = {}
                let productForm = this.closest('.product__info-wrapper').querySelector('product-form');
                let inputProperties = productForm.querySelectorAll('input[name^="properties"]');
              	for (let item of inputProperties) {
                        let propName = item.getAttribute('name');
                        propName = propName.replace('properties[', '').replace(']', '');
                        properties[propName] = item.val();
                    
                }
                addToBasketItems.push({
                    'id': accessoryselectedVarintId,
                    'quantity': 1,
                    properties: properties
                });
            }
        }

        if (addToBasketItems.length > 0) {
            let data = {
                'items': addToBasketItems
            }
            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    for (const accessory of this.querySelectorAll('.product_accessories_item')) {
                        accessory.querySelector('input[type=checkbox]').checked = false;
                    }
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }
    constructor() {
        super();
    }

    connectedCallback(){
        ProductFormValidation.addPreAddBasket(this.addSelectionToBasket);
        for (let select of this.querySelectorAll('.select__select')) {
            select.addEventListener('change', (e) => {
                var item = e.target.options[e.target.selectedIndex]
                select.closest('.fll').querySelector('.accessory-price').innerHTML = item.getAttribute('data-price');
            })
        }
    }
}
window.customElements.define('smiffys-product-accessories', SmiffysProductAccessories)